module.exports = __webpack_public_path__ + "static/media/blurred-image-blue.3be9151c.jpg";